var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 70,
    viewBox: "0 0 72 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.89543 0 2V68C0 69.1046 0.895431 70 2 70C3.10457 70 4 69.1046 4 68V60H68V68C68 69.1046 68.8954 70 70 70C71.1046 70 72 69.1046 72 68V2C72 0.895431 71.1046 0 70 0C68.8954 0 68 0.89543 68 2V8H4V2C4 0.895431 3.10457 0 2 0ZM4 12H68V32H4V12ZM4 36V56H68V36H4ZM8 41C8 40.4477 8.44771 40 9 40H23C23.5523 40 24 40.4477 24 41V51C24 51.5523 23.5523 52 23 52H9C8.44771 52 8 51.5523 8 51V41ZM29 40C28.4477 40 28 40.4477 28 41V51C28 51.5523 28.4477 52 29 52H43C43.5523 52 44 51.5523 44 51V41C44 40.4477 43.5523 40 43 40H29ZM48 41C48 40.4477 48.4477 40 49 40H63C63.5523 40 64 40.4477 64 41V51C64 51.5523 63.5523 52 63 52H49C48.4477 52 48 51.5523 48 51V41ZM9 16C8.44771 16 8 16.4477 8 17V27C8 27.5523 8.44771 28 9 28H23C23.5523 28 24 27.5523 24 27V17C24 16.4477 23.5523 16 23 16H9ZM28 17C28 16.4477 28.4477 16 29 16H43C43.5523 16 44 16.4477 44 17V27C44 27.5523 43.5523 28 43 28H29C28.4477 28 28 27.5523 28 27V17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStash);
export default __webpack_public_path__ + "static/media/stash.d9c02b974f0586b18c4447364e68050c.svg";
export { ForwardRef as ReactComponent };